import seatWidget from './seat-widget.js'

// import { seatingChartHeight, seatingChartWidth } from '../checkout/share-seats'

export function getSeatWidgetImageBv () {
  // const SELECTEDSEATS = isReviewCartPage
  //   ? read_cookie('seatsInCartObj') != null
  //     ? read_cookie('seatsInCartObj')
  //     : ''
  //   : selectedSeats

  const SCHEDULE_EID = window.bvScheduleId

  let selectSeatsEid = ''

  const chartWidth = 780
  const SEATINGCHARTHEIGHT = resultSeatingChart.width
  const SEATINGCHARTWIDTH = resultSeatingChart.height
  const chartRatio = SEATINGCHARTHEIGHT / SEATINGCHARTWIDTH

  const seatArray = document.querySelectorAll('[name="items[]"]')

  seatArray.forEach((elm, i ) => {
    const eid = elm.value
    if (i > 0) {
      selectSeatsEid += `,`
    }
    selectSeatsEid += eid
    console.info(selectSeatsEid)
  })

  const chartWidgetImgSrc = seatWidget(
    SCHEDULE_EID,
    selectSeatsEid,
    chartWidth,
    chartRatio,
    true
  )
  const chartWidgetImgSrc_h = seatWidget(
    SCHEDULE_EID,
    selectSeatsEid,
    chartWidth,
    chartRatio
  )

  $('#hidden-cart-items').val(selectSeatsEid)
  $('#hidden-chartwidget-horizontal').val(chartWidgetImgSrc_h)
  $('#hidden-chartwidget-vertical').val(chartWidgetImgSrc)

  console.info('chartWidgetImgSrc: ' + chartWidgetImgSrc)
  console.info('chartWidgetImgSrc_h: ' + chartWidgetImgSrc_h)

}

export default getSeatWidgetImageBv
